// Modal behavior adapted from BootstrapVue 2.21.2; see BOOTSTRAPVUE-LICENSE (MIT).
// Vue 3 equivalent of BootstrapVue's modal stack and scrollbar ownership.
import { shallowReactive } from 'vue'
export const modalStack = shallowReactive([])
let restore = []
let wasOpen = false
export let scrollbarWidth = 0
export let bodyOverflowing = false
export let baseZIndex = 1040
export function registerModal(modal) {
  if (modalStack.includes(modal)) return
  for (const other of [...modalStack]) if (other.noStacking()) other.hide()
  if (!modalStack.length) {
    const body = document.body
    wasOpen = body.classList.contains('modal-open')
    const measure = document.createElement('div')
    measure.className = 'modal-scrollbar-measure'
    body.append(measure)
    scrollbarWidth = measure.getBoundingClientRect().width - measure.clientWidth
    measure.remove()
    const backdrop = document.createElement('div')
    backdrop.className = 'modal-backdrop d-none'
    body.append(backdrop)
    baseZIndex = parseInt(getComputedStyle(backdrop).zIndex) || 1040
    backdrop.remove()
    const rect = body.getBoundingClientRect()
    bodyOverflowing = rect.left + rect.right < innerWidth
    const adjust = (el, property, amount) => {
      const before = el.style[property]
      restore.push(() => {
        el.style[property] = before
      })
      el.style[property] = `${(parseFloat(getComputedStyle(el)[property]) || 0) + amount}px`
    }
    if (bodyOverflowing) {
      document
        .querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')
        .forEach((el) => adjust(el, 'paddingRight', scrollbarWidth))
      document
        .querySelectorAll('.sticky-top')
        .forEach((el) => adjust(el, 'marginRight', -scrollbarWidth))
      document
        .querySelectorAll('.navbar-toggler')
        .forEach((el) => adjust(el, 'marginRight', scrollbarWidth))
      adjust(body, 'paddingRight', scrollbarWidth)
    }
    body.classList.add('modal-open')
  }
  modalStack.push(modal)
  document.body.dataset.modalOpenCount = String(modalStack.length)
}
export function unregisterModal(modal) {
  const index = modalStack.indexOf(modal)
  if (index < 0) return
  modalStack.splice(index, 1)
  document.body.dataset.modalOpenCount = String(modalStack.length)
  if (!modalStack.length) {
    for (const reset of restore.reverse()) reset()
    restore = []
    if (!wasOpen) document.body.classList.remove('modal-open')
  }
}
